import React from 'react';
import usePushNotifications from '../hooks/usePushNotifications';

/**
 * Minimal notification toggle — can be embedded in UserProfile or Settings page.
 * Push notifications auto-subscribe on login via Dashboard.
 * This component lets the user manually enable/disable if needed.
 */
export default function NotificationSettings() {
  const { isSupported, isEnabled, isLoading, error, enable, disable } =
    usePushNotifications();

  if (!isSupported) {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.alert, ...styles.alertWarning }}>
          Push notifications are not supported in this browser.
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h3 style={styles.title}>Push Notifications</h3>

        <div style={styles.row}>
          <div>
            <span style={styles.label}>Status: </span>
            <span
              style={{
                ...styles.badge,
                backgroundColor: isEnabled ? '#059669' : '#6b7280',
              }}
            >
              {isEnabled ? 'Enabled' : 'Disabled'}
            </span>
          </div>

          <button
            onClick={isEnabled ? disable : enable}
            disabled={isLoading}
            style={{
              ...styles.btn,
              ...(isEnabled ? styles.btnDanger : styles.btnPrimary),
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            {isLoading
              ? 'Processing…'
              : isEnabled
              ? 'Disable Notifications'
              : 'Enable Notifications'}
          </button>
        </div>

        {error && <div style={{ ...styles.alert, ...styles.alertError }}>{error}</div>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '16px',
    maxWidth: '480px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '10px',
    padding: '20px 24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    border: '1px solid #e5e7eb',
  },
  title: {
    margin: '0 0 16px 0',
    fontSize: '16px',
    fontWeight: 600,
    color: '#111827',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
  },
  badge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#fff',
  },
  btn: {
    padding: '8px 18px',
    fontSize: '13px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  btnPrimary: {
    backgroundColor: '#2563eb',
    color: '#fff',
  },
  btnDanger: {
    backgroundColor: '#dc2626',
    color: '#fff',
  },
  alert: {
    marginTop: '12px',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '13px',
  },
  alertError: {
    backgroundColor: '#fef2f2',
    color: '#991b1b',
    border: '1px solid #fecaca',
  },
  alertWarning: {
    backgroundColor: '#fffbeb',
    color: '#92400e',
    border: '1px solid #fde68a',
  },
};
